import React, { useState, useEffect, useContext, useRef } from "react";

import { SiteContext } from "../context/site";

const InputCode = ({ length, label, loading, onComplete }) => {
	
	const { 
		signeUp_codeLabel,
	}	= useContext( SiteContext );

  const [code, setCode] = useState([...Array(length)].map(() => ""));
  const inputs = useRef([]);
  // Typescript
  // useRef<(HTMLInputElement | null)[]>([])

  const processInput = (e, slot) => {
    const num = e.target.value;
    if (/[^0-9]/.test(num)) return;
    const newCode = [...code];
    newCode[slot] = num;
    setCode(newCode);
    if (slot !== length - 1) {
      inputs.current[slot + 1].focus();
    }
    if (newCode.every(num => num !== "")) {
      onComplete(newCode.join(""));
    }
  };

  const onKeyUp = (e, slot) => {
    if (e.keyCode === 8 && !code[slot] && slot !== 0) {
      const newCode = [...code];
      newCode[slot - 1] = "";
      setCode(newCode);
      inputs.current[slot - 1].focus();
    }
  };


	const handlePaste = (e) => {
	  e.preventDefault();

	  const pasted = e.clipboardData
		.getData('text')
		.replace(/\D/g, ''); // <-- remove ALL non-digits

	  if (!pasted) return;

	  const digits = pasted.slice(0, length).split('');
	  const newCode = [...code];

	  digits.forEach((digit, idx) => {
		newCode[idx] = digit;
	  });

	  setCode(newCode);

	  // focus next empty input
	  const nextIndex = digits.length >= length ? length - 1 : digits.length;
	  inputs.current[nextIndex]?.focus();

	  if (digits.length === length) {
		onComplete(digits.join(''));
	  }
	};

	useEffect(() => {
	  setCode([...Array(length)].map(() => ""));
	}, [length]);

  return (
    <div className="code-input">
      <label className="code-label">{ signeUp_codeLabel }</label>
      <div className="code-inputs">
        {code.map((num, idx) => {
          return (		  
            <input
			  key={idx}
			  type="text"
			  inputMode="numeric"
			  autoComplete="one-time-code"
			  maxLength={1}
			  value={num}
			  autoFocus={!code[0].length && idx === 0}
			  readOnly={loading}
			  onChange={e => processInput(e, idx)}
			  onKeyUp={e => onKeyUp(e, idx)}
			  onPaste={handlePaste}
			  ref={ref => (inputs.current[idx] = ref)}
			/>
          );
        })}
      </div>
    </div>
  );
};

export default InputCode;
